<template>
    <div id="app">
        <canvas id="canvas"></canvas>
        <headers class="header"></headers>
        <div class="container">
            <router-view/>
        </div>
  </div>
</template>

<script>
import headers from './components/headers'
export default {
    name: 'App',
    components:{headers},
    data() {
        return {
      
        }
    },
    methods: {
        initCanvas() {
            let that = this
            let cvs = document.getElementById('canvas')
            let ctx = cvs.getContext('2d')
            let w = cvs.width = window.innerWidth
            let h = cvs.height = window.innerHeight
            let circles = []
            window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame
            let draw = function () {
                ctx.clearRect(0, 0, w, h)
                circles.forEach(function (item) {
                    item.move(w, h)
                    item.drawCircle(ctx)
                })
                window.requestAnimationFrame(draw)
            }
            let init = function (num) {
                for (let i = 0; i < num; i++) {
                    circles.push(new that.Circle(Math.random() * w, Math.random() * h, Math.random() / 2))
                }
                draw()
            }
            init(60)
        },
        Circle (x, y, alpha) {
            this.x = x
            this.y = y
            this.r = Math.random() * 20 + 3
            this._mx = Math.random() * 2 - 1
            this._my = Math.random() * 2 - 1
            this.alpha = alpha

            this.drawCircle = function (ctx) {
                let pr = window.devicePixelRatio || 1
                ctx.scale(pr, pr)
                ctx.globalAlpha = this.alpha
                ctx.beginPath()
                ctx.arc(this.x, this.y, this.r, 0, 360)
                ctx.closePath()
                // ctx.fillStyle = 'rgba(204, 204, 204, .3)'
                ctx.fillStyle = '#' + (Math.cos(this.r) * 127 + 128 << 16 | Math.cos(this.r + Math.PI * 2 / 3) * 127 + 128 << 8 | Math.cos(this.r + Math.PI * 2 / 3 * 2) * 127 + 128).toString(16)
                ctx.fill()
            }

            this.drawLine = function (ctx, _circle) {
                let dx = this.x - _circle.x
                let dy = this.y - _circle.y
                let d = Math.sqrt(dx * dx + dy * dy)
                if (d < 150) {
                    ctx.beginPath()
                    ctx.moveTo(this.x, this.y)// 起始点
                    ctx.lineTo(_circle.x, _circle.y)// 终点
                    ctx.closePath()
                    ctx.strokeStyle = 'rgba(204, 204, 204, 0.1)'
                    ctx.stroke()
                }
            }

            this.move = function (w, h) {
                this._mx = (this.x + this.r < w && this.x - this.r > 0) ? this._mx : (-this._mx)
                this._my = (this.y + this.r < h && this.y - this.r > 0) ? this._my : (-this._my)
                this.x += this._mx / 2
                this.y += this._my / 2
            }
        }
    },
    created() {

    },
    mounted() {
        this.initCanvas()
    }
}
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>
/deep/ .el-table th.el-table__cell>.cell{
    color: #262626;
    font: 400 1vw/1vw PingFangSC-Regular, PingFang SC;
}
/deep/ .el-table .cell{
    color: #262626;
    font: 400 0.8vw/1vw PingFangSC-Regular, PingFang SC;
}
/deep/ .el-pagination{
    text-align: center;
    margin-top: 20px;
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #FFD143;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: #FFD143 !important;
    border-color: #FFD143 !important;
}
/deep/ .el-table tr {
    background-color: #F8F8F8;
    color: #555555;
}
/deep/.el-table td.el-table__cell,/deep/ .el-table th.el-table__cell.is-leaf{
    border-bottom: 2px solid #FFFFFF;
}
/deep/.el-table::before{
    height: 0;
}
/deep/ .el-input{
    width: 16vw;
    height: 2.2vw;
    border-radius: 6px;
    background-color: #F0F0F0;
}
/deep/ .el-input__inner{
    border: none;
    background-color: #F0F0F0;
}
/deep/ .el-radio__input.is-checked .el-radio__inner{
    border-color: #FFD143;
    background: #FFD143;
}
/deep/ .el-radio__input.is-checked+.el-radio__label{
    color: #FFD143;
}
/deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #FFB300;
}
/deep/ .el-upload-dragger .el-icon-upload{
    font-size: 12px;
    color: #ffffff;
    margin: 0;
    line-height: 12px;
}
/deep/ .el-button--primary{
    color: #262626;
    background-color: #FFB300;
    border-color: #FFB300;
}
#app {
  min-width: 980px;
  padding-top: 5.365vw;
}
.header{
  z-index: 11;
}
.container{
  height: calc(100vh - 5.365vw);
  width: 100%;
  z-index: 11;
}
#canvas{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue